import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const OccurrenceHistoryService = {
    getOccurrenceHistory: async (id) => axios.get(API_URL + `/reports/occurrence_history/${id}`).then(({ data }) => data).catch((err) => { throw err }),
}

export default OccurrenceHistoryService;